import React from "react";

const HeroSection = () => {
  return (
    <section className="about">
      <div className="bg-image">
        <div className="bg-overlay"></div>
        <div className="container content">
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <h2>About Us</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
